import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import { useFullIds } from "storybook-dashboard/utils/hooks";
import Im from "immutable";

function StyleSetter({ currentStyles, dispatch }) {
  let { project, company } = useFullIds();

  let host = company || project;
  let styles = host?.getIn(["meta_json", "styles"]) || Im.Map();

  useEffect(() => {
    if (!styles.equals(currentStyles)) {
      console.log("UPDATING GLOBAL STYLES", styles.toJS());
      dispatch({
        type: "UI_SET_IN",
        payload: styles,
        stateParams: { itemPath: `styles` },
      });
    }
  });

  return null;
}

const mapStateToProps = (state, ownProps) => ({
  currentStyles: state.getIn(["ui", "styles"]) || Im.Map(),
});

export default connect(mapStateToProps)(StyleSetter);
